"use strict";

var hostname = window.location.origin;
$(document).ready(function () {
    var href = window.location.href;
    var path = href.split('/');
    var reversePath = path.reverse();
    var isSuperAdminTickets = false;
    var isSuperAdminTicketsSearch = false;
    var isSuperAdminCollabo = false;
    /*------ CHECK HOSTNAME ------*/

    if (hostname == 'https://localhost' || hostname == 'http://localhost') {
        hostname += '/portailV1/public';
    }
    /* ----- DATEPICKER -----*/


    if ($('.datepicker').length) {
        $.datepicker.setDefaults($.datepicker.regional['fr']);
        $(".datepicker").datepicker({
            dateFormat: 'yy-mm-dd',
            maxDate: new Date()
        });
    }
    /*------ DATATABLE ------*/
    // Check if we are on the tickets page of the Super Admin


    for (var i = 0; i < path.length; i++) {
        if (path[i] == 'tickets' && path[i - 1] == 'all') {
            isSuperAdminTickets = true;
        }

        if (path[i] == 'tickets' && path[i - 1] == 'search') {
            isSuperAdminTicketsSearch = true;
        }
    } // Check if we are on the collaborators page of the Super Admin


    if ($('.myCollaborator #collaborators-table_wrapper[data-admin="superAdmin"]').length != 0) {
        isSuperAdminCollabo = true;
    } // DataTable


    $(function () {
        if (isSuperAdminTickets) {
            $('[data-dt-idx]').each(function () {
                $(this).on('click', function (e) {
                    e.preventDefault();
                    $('#searchForm').attr('action', $(this).attr('href')).trigger('submit');
                });
            });
            $('table:not("#collaborators-table"):not("#tickets-table"):not(".no-auto-initialize"):not(".phpdebugbar-widgets-params"):not(".no-datatable")').DataTable({
                "language": {
                    "url": "//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/French.json"
                },
                searching: false,
                ordering: false
            });
        } else if (isSuperAdminTicketsSearch) {
            $('table:not(".no-auto-initialize"):not(".phpdebugbar-widgets-params"):not(".no-datatable")').DataTable({
                "language": {
                    "url": "//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/French.json"
                },
                searching: false,
                ordering: true
            });
        } else {
            var table = $('table:not(#collaborators-table):not(.no-auto-initialize):not(".phpdebugbar-widgets-params"):not(".no-datatable")');
            table.DataTable({
                "language": {
                    "url": "//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/French.json"
                },
                retrieve: true,
                searching: true,
                ordering: false
            });
        }

        if (!isSuperAdminCollabo) {
            $('#myCollaboratorTable #collaborators-table').DataTable({
                "language": {
                    "url": "//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/French.json"
                },
                retrieve: true,
                searching: true,
                ordering: false
            });
        }
    }); // CUSTOM DATATABLES
    // Tickets

    if (isSuperAdminTickets) {
        var defaultPagination = false; // Check pagination

        if (reversePath[2] == 10 || reversePath[2] == 25 || reversePath[2] == 50 || reversePath[2] == 100) {
            $(".tickets select[name='tickets-table_length']").val(reversePath[2]);
        } else {
            defaultPagination = true;
            $(".tickets select[name='tickets-table_length']").val(10);
        } // Change pagination


        $(".tickets select[name='tickets-table_length']").on('change', function () {
            var nextPath = window.location.href + '/pagination/' + $(this).val() + '/1/7';

            if (!defaultPagination) {
                reversePath[2] = $(this).val();
                reversePath = path.reverse();
                reversePath = path.join('/');
                nextPath = reversePath;
            }

            $('#searchForm').attr('action', nextPath).trigger('submit');
        }); // Disable the next button or the previous button

        $('ul.pagination li').each(function () {
            if ($(this).hasClass('previous') && $(this).next().hasClass('active') || $(this).hasClass('previous') && $(this).next().hasClass('next') || $(this).hasClass('next') && $(this).prev().hasClass('previous') || $(this).hasClass('next') && $(this).prev().hasClass('active')) {
                $(this).addClass('disabled');
                $(this).disabled = true;
                $(this).children()[0].href = '#';
            }
        });
    } // Collabo


    if (isSuperAdminCollabo) {
        var _defaultPagination = false; // Check pagination

        if (reversePath[2] == 10 || reversePath[2] == 25 || reversePath[2] == 50 || reversePath[2] == 100) {
            $(".myCollaborator select[name='collaborators-table_length']").val(reversePath[2]);
        } else {
            _defaultPagination = true;
            $(".myCollaborator select[name='collaborators-table_length']").val(10);
        } // Change pagination


        $(".myCollaborator select[name='collaborators-table_length']").on('change', function () {
            if (_defaultPagination) {
                window.location.href += '/pagination/' + $(this).val() + '/1/7';
            } else {
                reversePath[2] = $(this).val();
                reversePath = path.reverse();
                reversePath = path.join('/');
                window.location.replace(reversePath);
            }
        }); // Disable the next button or the previous button

        $('ul.pagination li').each(function () {
            if ($(this).hasClass('previous') && $(this).next().hasClass('active') || $(this).hasClass('previous') && $(this).next().hasClass('next') || $(this).hasClass('next') && $(this).prev().hasClass('previous') || $(this).hasClass('next') && $(this).prev().hasClass('active')) {
                $(this).addClass('disabled');
                $(this).disabled = true;
                $(this).children()[0].href = '#';
            }
        });
    }
    /*------ USER ACTIVATION - MAIL CHECKBOX ------*/


    if ($('.collaboratorManagement').length) {
        if (!$($('[name="actif"]')[1]).prop('checked')) {
            $('#actifSwitchContainer').hide();
        }

        $('#actifSwitchUnique').on('click', function () {
            if (!$($('[name="actif"]')[1]).prop('checked')) {
                $('#actifSwitchContainer').show();
                $('#actifSwitchContainer input:nth-child(2)').prop('checked', true);
            } else {
                $('#actifSwitchContainer').hide();
                $('#actifSwitchContainer input:nth-child(2)').prop('checked', false);
            }
        });
    }
    /*------ CHARACTER COUNTER ------*/
    // Character counter Ticket
    // Not used anymore
    // $('.createTicket #description').keyup(function(e){
    // $('.createTicket #descriptionCharContainer #descriptionChar').text($(this).val().length);
    // });
    // Character counter Event


    $('.createEvent #description').on('keyup', function (e) {
        $('.createEvent #descriptionCharContainer #descriptionChar').text($(this).val().length);
    }); // --- TICKET SKILL AREA --- //

    $('.createTicket :checked:not(#sendMail)').prop('checked', false);
    $('.autocompleteForm .spinner').hide();
    $(document).on('change', '.createTicket .type_nature_block input[type="radio"]', function () {
        $('.informations_complementaires').remove();
        $(".createTicket .type_nature_block input:not(:checked)").parent('div').removeClass('checked')
        $('.createTicket .first_step').hide();
        $('.createTicket .second_step').hide();
        $('.createTicket .third_step').hide();
        $('.createTicket .priority_block input[type="radio"]').prop('checked', false);
        $('.createTicket .priority_block input:not(:checked)').parent('div').removeClass('checked');

        var type_nature = $(this).val();
        $(this).parent().addClass('checked');
        var contactVal = null;
        if ($('.createTicket #autocomplete').length) contactVal = $('.createTicket #autocomplete').val();
        var input = $(this);


        $.ajax({
            url: hostname + '/ajaxcall',
            type: 'GET',
            data: {
                contact: contactVal,
                type_nature: type_nature
            }
        }).done(function (data) {
            $('.createTicket .nature_block').html(data);

            if (data == "") {
                $('.first_step .nature_block .itemcheck #Technique').prop('checked', true);
                $('.createTicket .second_step').show();
            } else if (input.attr('id') != 'Jenesaispas') {
                $('.createTicket .first_step').show();
                $('.createTicket .nature_block input[type="radio"]').on('change', function () {
                    $('.createTicket .second_step').hide();
                    $('.createTicket .third_step').hide();
                    $('.createTicket .priority_block input:not(:checked)').parent('div').removeClass('checked');
                    $('.createTicket .priority_block input[type="radio"]').prop('checked', false);
                    $('.createTicket .nature_block input:not(:checked)').parent('div').removeClass('checked');
                    $('.createTicket .nature_block .itemcheck').removeClass('checked');
                    $(this).parent().addClass('checked');
                    $('.createTicket .second_step').show();
                    suggestion($("input#description")[0]);
                });
            } else {
                $('.first_step .nature_block .itemcheck #Jenesaispas').prop('checked', true);
                $('.createTicket .second_step').show();
                suggestion($("input#description")[0]);
            }
        }).fail(function (e) {
            console.log(e.status + ' : ' + e.responseText);

            if (e.status == 404) {
                $('#autocomplete').parent().addClass('has-error');
                $('#autocomplete + .help-block').removeClass('hidden');
                $(':checked').prop('checked', false);
                hideAllStep();
            }
        });
    });

    function getComplementInfos(e) {
        if ((e.target.name == "nature" || e.target.name == "fav_nature") && e.target.dataset.type == "spurgin") {
            $.ajax({
                url: hostname + '/ajaxcall-getComplement/' + e.target.value,
                type: 'GET',
                dataType: 'json'
            }).done(function (data) {
                console.log(data)
                $('.informations_complementaires').remove();
                if (data.infos_complementaires != null) {
                    let label = '<label for="infos_complementaires">' + data.infos_complementaires + '</label>'
                    let inputDiv = '<div class="form-group informations_complementaires">' + label + '<input class="form-control" name="informations_complementaires" type="text" id="informations_complementaires" maxlength="200"><input id="infos_comp_label" name="infos_comp_label" type="hidden" value="' + data.infos_complementaires + '"></div>'
                    $(inputDiv).insertAfter('.first_step')
                }
            }).fail(function (e) {
                if (e.status == 404) {
                    $('#autocomplete').parent().addClass('has-error');
                    $('#autocomplete + .help-block').removeClass('hidden');
                    $(':checked').prop('checked', false);
                    hideAllStep();
                }
            });
        }
    }

    $(document).on('change', $('.first_step input[type="radio"]'), function (e) {
        getComplementInfos(e);
    })


    $('.createTicket .favoriteNature input[type="radio"]').on('change', function (e) {
        getComplementInfos(e);
        var val = $(this).val();
        $('.informations_complementaires').remove();
        $('.createTicket .favoriteNature .btn-success').removeClass('btn-success text-white').addClass('btn-light text-oci-primary-dark');
        $('.createTicket .priority_block input[type="radio"]').prop('checked', false);
        $('.createTicket .priority_block').removeClass('checked');
        $('.createTicket .priority_block input:not(:checked)').parent('div').removeClass('checked');
        $('.createTicket .first_step input[type="radio"]').prop('checked', false);
        $('.createTicket .first_step .itemcheck').removeClass('checked');
        $('.createTicket .first_step').hide();
        $('.createTicket .third_step').hide();
        $(this).parent().removeClass('btn-light text-oci-primary-dark').addClass('btn-success text-white');
        suggestion($("input#description")[0]);

        if (val == "0") {
            $('.createTicket .admin_step').show();
            $('.createTicket .second_step').hide();
        } else {
            $('.createTicket .second_step').show();
            $('.createTicket .admin_step').hide();
            $('.createTicket .admin_step input[type="radio"]').prop('checked', false);
            $('.createTicket .admin_step .itemcheck').removeClass('checked');
        }
    });

    $('.createTicket .nature_block input[type="radio"]').on('change', function () {
        $('.createTicket .nature_block .itemcheck').removeClass('checked');
        $('.createTicket .second_step').hide();
        $('.createTicket .third_step').hide();
        $('.createTicket .priority_block input[type="radio"]').prop('checked', false);
        $('.createTicket .priority_block input:not(:checked)').parent('div').removeClass('checked');
        $(this).parent().addClass('checked');
        $('.createTicket .second_step').show();
        suggestion($("input#description")[0]);
    });
    $(document).on('change', '.createTicket .priority_block input[type="radio"]', function () {
        $('.createTicket .third_step').hide(); // $('.priority_block input[type="radio"]').prop('checked', false);

        $('.createTicket .priority_block input:not(:checked)').parent('div').removeClass('checked');

        $(this).parent().addClass('checked');
        $('.createTicket .third_step').show();
        if ($('#Siteweb').prop('checked'))
            $('.webonly').show();
        else
            $('.webonly').hide();

    }); // --- END TICKET SKILL AREA --- //

    /*------ Autocomplete another contact ------*/
    // if ($('#autocompleteBeneficiaire').length) {
    //     $('#autocompleteBeneficiaire').autocomplete({
    //         source: function (request, response) {
    //             $.get(route('contact.autocompleteContacts'), {
    //                 term: request.term,
    //                 contact: $("#autocomplete").length ? $("#autocomplete").val().split(' |')[0] : null
    //             }, function (data) {
    //                 response(data);
    //             });
    //         },
    //         minLength: 3,
    //         autoFocus: true,
    //         select: function select(event, ui) {
    //             console.log(ui.item.clientNo);
    //             console.log(ui.item);
    //             $('#beneficiaire_id').val(ui.item.clientNo);
    //         },
    //         search: function search() {
    //             $('.autocompleteForm #beneficiaire .spinner').show();
    //         },
    //         response: function response() {
    //             $('.autocompleteForm #beneficiaire .spinner').hide();
    //         }
    //     });
    // }

    /*------ CREATE TICKET - EVENT ADMIN / AUTOCOMPLETE ------*/
    if ($('.autocompleteForm #autocomplete').length) {
        $('.autocompleteForm #autocomplete').autocomplete({
            source: route('contact.autocomplete'),
            minLength: 3,
            autoFocus: true,
            select: function select(event, ui) {
                console.log('test');
                if ($('.createTicket').length) {
                    $('.autocompleteForm #contactBlock .spinner').show();
                }
                console.log(ui.item);
                $.ajax({
                    url: hostname + '/ajaxcallSuperAdmin',
                    type: 'GET',
                    data: {
                        contact: ui.item.value
                    }
                }).done(function (data) {
                    if ($('.createTicket').length) {
                        $('.autocompleteForm .admin_step').show();
                        ajoutBtnRadio(data.nature);
                        updateContract(data.nature);
                        updatePriority(ui.item.value.split(' |')[0]);

                        if (!data.fcn) {
                            $('#js_show-fcn').remove();
                        }

                        $('.autocompleteForm #contactBlock .spinner').hide();
                    }
                }).fail(function (e) {
                    console.log(e.status + ' : ' + e.responseText);
                });
            },
            change: function change() {
                if ($('.createTicket').length) {
                    $(':checked').prop('checked', false);
                    if (!$('.createTicket #autocomplete').val()) {
                        hideAllStep();
                    }
                }
            },
            search: function search() {
                $('.autocompleteForm #contactBlock .spinner').show();
            },
            response: function response() {
                $('.autocompleteForm #contactBlock .spinner').hide();
            }
        });
    }
    /*------ COLLABO MANAGEMENT / AUTOCOMPLETE ------*/


    if ($('.myCollaborator #autocomplete').length) {
        $('.myCollaborator #autocomplete.gestionDesEntreprises').autocomplete({
            source: route('autocompleteCustomer'),
            minLength: 3,
            autoFocus: true,
            select: function select(event, ui) {
                $('.myCollaborator #autocomplete').val(ui.item.value);
                $('#searchForm').trigger('submit');
            }
        });
        $('.myCollaborator #autocomplete.gestionDesEntreprisesActives').autocomplete({
            source: hostname + '/autocompleteCustomerActive',
            minLength: 3,
            autoFocus: true,
            select: function select(event, ui) {
                $('.myCollaborator #autocomplete').val(ui.item.value);
                $('#searchForm').trigger('submit');
            }
        });
    }
    /*------ SKILL AREA ------*/
    // Init


    $('.nature-data').each(function () {
        skillAreaPriority($(this).find('.skillArea-data'));
    }); // Listener

    if ($('#companyEdit')) {
        $('.switch').on('change', function () {
            //let id = element.attr('data-skillArea-id');
            var nature = $(this).attr('data-nature');
            var skillsAreas = $('.skillArea-data[data-nature="' + nature + '"]');

            if ($(this).parent().hasClass('skillArea-priority')) {
                var priorityCheckbox = $('.skillArea-priority [data-nature="' + nature + '"]');
                disabledSkillAreaPriority(priorityCheckbox, $(this).attr('data-priority-id'));

                if (!$(this).find('input[type="checkbox"]').prop('checked')) {
                    $(this).find('input[type="checkbox"]').prop('checked', true);
                }
            } else {
                skillAreaPriority(skillsAreas);
            }
        });
    }
    /*------ CHANGE COMPANY MODAL ------*/


    $('a#changeCompany').on('click', function (e) {
        e.preventDefault();
        $('#changeCompanyModal').modal('show');
    });
    /* -- SHOW MORE TICKETS -- */

    $('.showmore').on('click', function () {
        if ($(this).hasClass("active")) {
            $(this).removeClass('active');
            $('.tck-events').slideUp().removeClass('active').empty();
        } else {
            // Spinner
            var icon = $(this).find('i');
            var navicon = icon.attr('class');
            icon.removeClass(navicon);
            icon.addClass('ion-load-c spinner');
            let ticket_id = $(this).attr('data-ticket-id');
            $('.showmore').removeClass('active');
            $('.tck-events').slideUp().removeClass('active').empty();
            $(this).addClass('active');
            $.ajax({
                url: route('tickets.getEvents', ticket_id),
                type: 'GET'
            }).done(function (data) {
                icon.removeClass('ion-load-c spinner');
                icon.addClass(navicon);
                $('.tck-' + ticket_id + ' .tck-events').html(data);
                $('.tck-' + ticket_id + ' .tck-events').slideDown().addClass('active');
            }).fail(function (e) {
                console.log(e.status + ' : ' + e.responseText);
            });
        }
    });
    /* -- END SHOW MORE TICKETS -- */

    /*-- STAR RATING --*/

    $('.starview.active').on('click', function () {
        var ticket = $(this).attr('ticket');
        $.ajax({
            url: route('tickets.getComment', ticket),
            type: 'GET',
        }).done(function (data) {
            $('#sendCommentModal').modal('show');
            $('#numTicketComment').val(ticket);
            $("#commentNote").val(data.comment);
            $("#noteTicketComment").val(data.note);
        }).fail(function (e) {
            console.log(e.status + ' : ' + e.responseText);
        });
    });
    $('.star:not(.article-stars)').on('click', function () {
        var note = $(this).attr('note');
        var ticket = $(this).attr('ticket');
        var confirmation = true;
        if (!$(this).hasClass('active') || $(this).next().hasClass('active')) confirmation = confirm('Confirmez-vous la notation de ce ticket par la note de ' + note + ' ?');

        if (confirmation) {
            $.ajax({
                url: route('tickets.vote', ticket),
                type: 'GET',
                data: {
                    note: note,
                }
            }).done(function (data) {
                $(".stars[ticket='" + ticket + "']").each(function () {
                    if ($(this).attr('note') <= data) {
                        $(this).addClass('ion-ios-star');
                        $(this).removeClass('ion-ios-star-outline');
                    } else {
                        $(this).removeClass('ion-ios-star');
                        $(this).addClass('ion-ios-star-outline');
                    }
                });
            }).fail(function (e) {
                console.log(e);
                console.log(e.status + ' : ' + e.responseText);
            });
            $.ajax({
                url: route('tickets.getComment', ticket),
                type: 'GET',
            }).done(function (data) {
                console.log(data);
                $('#sendCommentModal').modal('show');
                $('#numTicketComment').val(ticket);
                $("#commentNote").val(data.comment);
                $("#noteTicketComment").val(data.note);
            }).fail(function (e) {
                console.log(e.status + ' : ' + e.responseText);
            });
            return false;
        }
    });
    $("#submitComment").on('click', function () {
        var ticket = $('#numTicketComment').val();
        var commentaire = $("#commentNote").val();

        $.ajax({
            url: route('tickets.comment', ticket),
            type: 'GET',
            data: {
                commentaire: commentaire,
            }
        }).done(function (data) {
            $('#sendCommentModal').modal('hide');
            $("#commentNote").val('');
        }).fail(function (e) {
            console.log(e.status + ' : ' + e.responseText);
        });
    });

    if ($(window).width() < 769) {
        $('body').addClass('client-record-menu-collapse');
    }

    $('.sidebar-client-record-toggle').on('click', function () {
        $('body').toggleClass('client-record-menu-collapse', 500);
    }); //* Is Client connect */

    $(document).on('change', '#isConnect', function () {
        $('#js_isConnectArea').fadeToggle();
    });

    if (showModal) {
        $('#changeCompanyModal').modal('show');

        $('input[name="remember"]').iCheck({
            checkboxClass: 'icheckbox_square-blue',
            radioClass: 'iradio_square-blue',
            increaseArea: '20%'
        });
    }

    
    $(".collapse").each(function() {
        if($('div.hasnt', this).length==$('div',this).length)
        $(this).siblings('a').addClass('hasnt');
    });

}); // Add or remove the check box priority

function skillAreaPriority(skillsAreas) {
    var nature = $(skillsAreas[0]).parent().attr('data-nature');

    if (nbSkillAreaChecked(skillsAreas) >= 2) {
        var priorities = $('.nature-data[data-nature="' + nature + '"] .skillArea-priority input[type="checkbox"]'); // hide or show priorities
        console.log(priorities);
        skillsAreas.each(function () {
            if ($(this).find('[data-nature="' + $(this).attr('data-nature') + '"] input[type="checkbox"]').prop('checked')) {
                $(this).find('.skillArea-priority').show();
            } else {
                $(this).find('.skillArea-priority').hide();
            }
        }); // check or not priorities

        var priorityCheck = false;
        priorities.each(function () {
            if ($(this).prop('checked')) {
                priorityCheck = true;
            }
        });

        if (!priorityCheck) {
            $(priorities[0]).prop('checked', true);
        }
    } else {
        skillsAreas.each(function () {
            var priority = $(this).find('.skillArea-priority input[type="checkbox"]');

            if ($(this).find('[data-nature="' + $(this).attr('data-nature') + '"] input[type="checkbox"]').prop('checked')) {
                priority.prop('checked', true);
            } else {
                // priority.removeAttr('checked');
                priority.prop("disabled", false);
            }

            $(this).find('.skillArea-priority').hide();
        });
    }
} // Count how many skill area are checked


function nbSkillAreaChecked(skillsAreas) {
    var nbSkillAreaChecked = 0;
    skillsAreas.each(function () {
        if ($(this).find('input[type="checkbox"]').prop('checked')) {
            nbSkillAreaChecked++;
        }
    });
    return nbSkillAreaChecked;
} // Disabled priority or not


function disabledSkillAreaPriority(priorityCheckbox, id) {
    priorityCheckbox.each(function () {
        if ($(this).attr('data-priority-id') != id) {
            $(this).find('input[type="checkbox"]').prop('checked', false);
        }
    });
} // Update all contract of the user selected


function ajoutBtnRadio(data) {
    $('.type_nature_block').html('');

    for (var i = 0; i < data.length; i++) {
        var html = `
            <div class="form-group btn btn-light text-oci-primary-dark itemcheck mx-1">
                <span
                    data-type="${data[i].alias}">
                </span>
                <label class="form-check-label" for="${data[i].alias}">
                    <i class="nature-type" nature-type="${data[i].alias}"></i>
                    ${data[i].alias}
                </label>
                <input id=${data[i].alias} name="type_nature" type="radio" value="${data[i].id}">
            </div>
        `;
        $('.type_nature_block').append(html);
    }
} // Update all contract of the user selected


function updateContract(data) {
    $('.type_nature_block span.itemcheck').hide();

    for (var i = 0; i < data.length; i++) {
        console.log(data[i].nature_type);

        var radioContainer = $('[data-type="' + data[i].alias + '"]');
        radioContainer.show();
    }
} // Function to hide all step in create ticket super amdin

function updatePriority(numClient) {
    $.ajax({
        url: route('clientPriorite', numClient),
        type: 'GET',
    }).done(function (data) {
        $('.priority_block').html('');
        $('.priority_block').append(data);
    }).fail(function (e) {
        console.log(e.status + ' : ' + e.responseText);
    });
}

function hideAllStep() {
    $('.admin_step').hide();
    $('.first_step').hide();
    $('.second_step').hide();
    $('.third_step').hide();
}

function showMore(event) {
    var url = event.data.url;

    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $('.tck-events').slideUp().removeClass('active').empty();
    } else {
        // Spinner
        var icon = $(this).find('i');
        var navicon = icon.attr('class');
        icon.removeClass(navicon);
        icon.addClass('ion-load-c spinner');
        var numNav = $(this).attr('numNav');
        $('.showmore_regies').removeClass('active');
        $('.tck-events').slideUp().removeClass('active').empty();
        $(this).addClass('active');
        $.ajax({
            url: hostname + url,
            type: 'GET',
            data: {
                documentNo: numNav
            }
        }).done(function (data) {
            icon.removeClass('ion-load-c spinner');
            icon.addClass(navicon);
            $('.tck-' + numNav + ' .tck-events').html(data);
            $('.tck-' + numNav + ' .tck-events').slideDown().addClass('active');
        }).fail(function (e) {
            console.log(e.status + ' : ' + e.responseText);
        });
    }
}

var suggestAjax;

function suggestion(input) {
    var term = input.value;
    var ajax = input.dataset.suggestionajax;

    var nature = $('input[name="nature"]:checked');

    if (nature.length == 0) {
        nature = $('input[name="fav_nature"]:checked');
        var text = '';
    } else {
        var text = nature[0].labels.length > 0 ? nature[0].labels[0].innerText : nature[0].id;
    }

    if (suggestAjax) {
        suggestAjax.abort();
    }

    suggestAjax = $.ajax({
        method: 'get',
        url: ajax,
        data: {
            isPublished: 1,
            term: term,
            natures: [text]
        }
    }).done(function (res) {
        $('div#article-suggestion-list').html(res);
    }).fail(function () { });
}


$('.createTicket').on('click', '.form-group', function () {
    var radio = $(this).find('input[type="radio"]');
    if (radio.length > 0) {
        radio.prop('checked', true);
    }
    radio.trigger('change');
});